// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rewards-popover-container,
.rewards-popover-section {
  color: #59606D;
}
.rewards-popover-container .focusable:focus,
.rewards-popover-section .focusable:focus {
  text-decoration: underline;
}
.redeem-section h4 {
  margin: -2px 0 12px;
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
  color: #59606D;
}
@media screen and (max-width: 735px) {
  .rewards-drawer .ant-drawer-body {
    padding-top: 0;
  }
}
.rewards-section .rewards-header {
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
}
.rewards-section .rewards-header .gift-code-callout-header {
  color: #59606D;
  margin-left: 3px;
}
@media screen and (max-width: 735px) {
  .rewards-section .rewards-header .gift-code-callout-header {
    font-size: 16px;
    line-height: 24px;
  }
}
.rewards-section .balance {
  color: black;
}
.rewards-section .ant-divider {
  margin: 16px 0;
  border-top: 1px solid #C9D1DF;
}
.rewards-section .reward-gift-icon {
  width: 22px;
  height: 20px;
}
.rewards-section .gift-code-callout p {
  margin: 10px 0;
}
.rewards-section .gift-code-callout.gift-code-callout-secondary p {
  margin-top: 0;
}
.rewards-section .gift-code-callout-reward {
  margin-bottom: 24px;
}
.rewards-section .gift-code-callout-reward .congrats-header {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: black;
}
.rewards-section .gift-code-callout-reward .gift-code-text {
  margin-bottom: 10px;
}
.rewards-section .gift-code-callout-reward .anticon {
  width: 16px;
  vertical-align: baseline;
  fill: currentColor;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn {
  float: none;
  padding: 5px 12px !important;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
  height: 26px;
  border-color: unset;
  box-shadow: none;
  text-shadow: none;
  display: inline-block;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn.is-disabled {
  cursor: not-allowed;
}
.rewards-section .gift-code-callout-reward .deck-redeem-btn .gift-code-redeem-link:hover {
  color: unset;
}
.rewards-section .gift-code-callout-reward .nkl-tag {
  margin-right: 0;
}
.rewards-section .gift-code-expiration {
  margin-right: 10px;
  margin-left: 10px;
}
.rewards-section .gift-code-expiration strong {
  font-size: 16px;
}
.rewards-section .nkl-points-display {
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #59606D;
  display: flex;
  align-items: baseline;
}
.rewards-section .nkl-points-display .points-amount {
  font-size: 38px;
  font-weight: 700;
  margin-right: 6px;
  line-height: 52px;
}
@media screen and (max-width: 735px) {
  .rewards-section .nkl-points-display .points-amount {
    font-size: 30px;
    line-height: 40px;
  }
}
.rewards-section .nkl-points-display .points-label {
  text-transform: capitalize;
}
@media screen and (max-width: 735px) {
  .rewards-section .nkl-points-display .points-label {
    font-size: 18px;
    line-height: 28px;
  }
}
.rewards-section .nkl-account-display {
  margin-top: 24px;
  margin-bottom: 14px;
}
.rewards-section .nkl-account-display p {
  margin-bottom: 0;
}
.rewards-section .nkl-account-display.nkl-account-no-gift-codes {
  margin-top: 0;
}
.redeem-menu,
.arcade-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.redeem-menu .redeem-option,
.arcade-menu .redeem-option {
  flex-basis: auto;
  padding: 0;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
}
.redeem-menu .market-link,
.arcade-menu .market-link {
  display: block;
  cursor: pointer;
  width: 100%;
}
.redeem-menu .market-link:hover,
.arcade-menu .market-link:hover,
.redeem-menu .market-link:focus,
.arcade-menu .market-link:focus {
  text-decoration: none;
}
.redeem-menu .market-link:hover .link-label,
.arcade-menu .market-link:hover .link-label,
.redeem-menu .market-link:focus .link-label,
.arcade-menu .market-link:focus .link-label {
  background-color: #F5F7FA;
  border-radius: 8px;
}
.redeem-menu .market-link.is-disabled,
.arcade-menu .market-link.is-disabled {
  cursor: not-allowed;
}
.redeem-menu .icon,
.arcade-menu .icon {
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0 8px 0 4px;
}
.redeem-menu svg,
.arcade-menu svg {
  position: absolute;
  top: 0;
  width: 100%;
}
@media screen and (max-width: 735px) {
  .redeem-menu svg,
  .arcade-menu svg {
    width: auto;
  }
}
.redeem-menu .link-label,
.arcade-menu .link-label {
  display: flex;
  align-items: center;
  flex-basis: auto;
  width: 100%;
  height: 100%;
  margin-top: 5px;
  padding: 14px;
  color: #000;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  pointer-events: none;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label,
  .arcade-menu .link-label {
    padding: 0;
    padding-left: 8px;
    padding-right: 8px;
  }
}
.redeem-menu .link-label .rewards-store-description,
.arcade-menu .link-label .rewards-store-description {
  display: flex;
  flex-direction: column;
  align-self: start;
  max-width: 265px;
}
.redeem-menu .link-label img,
.arcade-menu .link-label img {
  height: 44px;
  margin-right: 10px;
  align-self: start;
}
.redeem-menu .link-label .link-text,
.arcade-menu .link-label .link-text {
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin-bottom: 2px;
  line-height: 24px;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label .link-text,
  .arcade-menu .link-label .link-text {
    font-size: 14px;
    line-height: 20px;
  }
}
.redeem-menu .link-label .sub-text,
.arcade-menu .link-label .sub-text {
  font-size: 14px;
  font-weight: 400;
  color: #59606D;
  line-height: 20px;
}
@media screen and (max-width: 735px) {
  .redeem-menu .link-label .sub-text,
  .arcade-menu .link-label .sub-text {
    font-size: 12px;
    line-height: 16px;
  }
}
.redeem-menu .deck-external-link-icon,
.arcade-menu .deck-external-link-icon {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: auto;
  color: #59606D;
}
@media screen and (max-width: 735px) {
  .redeem-menu .deck-external-link-icon,
  .arcade-menu .deck-external-link-icon {
    height: 100%;
    top: 8px;
  }
}
#deck-rewardsPopoverContainer .ant-popover-inner-content {
  padding: 0;
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./src/deck/rewards-popover/rewards-popover.less"],"names":[],"mappings":"AAAA;;EAEI,cAAA;AACJ;AAHA;;EAKQ,0BAAA;AAER;AAEA;EAEQ,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AADR;AAOQ;EAAA;IACI,cAAA;EAJV;AACF;AAQA;EAEQ,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAPR;AAAA;EAUY,cAAA;EACA,gBAAA;AAPZ;AASY;EAAA;IACI,eAAA;IACA,iBAAA;EANd;AACF;AAVA;EAqBQ,YAAA;AARR;AAbA;EAyBQ,cAAA;EACA,6BAAA;AATR;AAjBA;EA8BQ,WAAA;EACA,YAAA;AAVR;AArBA;EAoCY,cAAA;AAZZ;AAeQ;EAEQ,aAAA;AAdhB;AA3BA;EA+CQ,mBAAA;AAjBR;AA9BA;EAkDY,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAjBZ;AArCA;EA0DY,mBAAA;AAlBZ;AAxCA;EA8DY,WAAA;EACA,wBAAA;EACA,kBAAA;AAnBZ;AA7CA;EAoEY,WAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AApBZ;AAsBY;EACI,mBAAA;AApBhB;AA5DA;EAoFgB,YAAA;AArBhB;AA/DA;EAyFY,eAAA;AAvBZ;AAlEA;EA8FQ,kBAAA;EACA,iBAAA;AAzBR;AAtEA;EAkGY,eAAA;AAzBZ;AAzEA;EAuGQ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;AA3BR;AAlFA;EAgHY,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA3BZ;AA6BY;EAAA;IACI,eAAA;IACA,iBAAA;EA1Bd;AACF;AA9FA;EA4HY,0BAAA;AA3BZ;AA6BY;EAAA;IACI,eAAA;IACA,iBAAA;EA1Bd;AACF;AAvGA;EAsIQ,gBAAA;EACA,mBAAA;AA5BR;AA3GA;EA0IY,gBAAA;AA5BZ;AA+BQ;EACI,aAAA;AA7BZ;AAkCA;;EAEI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AAhCJ;AA0BA;;EASQ,gBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA/BR;AAgBA;;EAmBQ,cAAA;EACA,eAAA;EACA,WAAA;AA/BR;AAiCQ;;;;EAEI,qBAAA;AA7BZ;AA2BQ;;;;EAKQ,yBAAA;EACA,kBAAA;AA1BhB;AA8BQ;;EACI,mBAAA;AA3BZ;AAPA;;EAuCQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA5BR;AAdA;;EA8CQ,kBAAA;EACA,MAAA;EACA,WAAA;AA5BR;AA8BQ;EAAA;;IACI,WAAA;EA1BV;AACF;AA1BA;;EAwDQ,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA1BR;AA4BQ;EAAA;;IACI,UAAA;IACA,iBAAA;IACA,kBAAA;EAxBV;AACF;AAjDA;;EA4EY,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAvBZ;AAxDA;;EAmFY,YAAA;EACA,kBAAA;EACA,iBAAA;AAvBZ;AA9DA;;EAyFY,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAvBZ;AAyBY;EAAA;;IACI,eAAA;IACA,iBAAA;EArBd;AACF;AA7EA;;EAsGY,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AArBZ;AAuBY;EAAA;;IACI,eAAA;IACA,iBAAA;EAnBd;AACF;AA3FA;;EAmHQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AApBR;AAsBQ;EAAA;;IACI,YAAA;IACA,QAAA;EAlBV;AACF;AAsBA;EAEQ,UAAA;EACA,WAAA;AArBR","sourcesContent":[".rewards-popover-container,\n.rewards-popover-section {\n    color: #59606D;\n\n    .focusable:focus {\n        text-decoration: underline;\n    }\n}\n\n.redeem-section {\n    h4 {\n        margin: -2px 0 12px;\n        font-size: 18px;\n        line-height: 1;\n        font-weight: 600;\n        color: #59606D;\n    }\n}\n\n.rewards-drawer {\n    .ant-drawer-body {\n        @media screen and (max-width: 735px) {\n            padding-top: 0;\n        }\n    }\n}\n\n.rewards-section {\n    .rewards-header {\n        margin-bottom: 24px;\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n\n        .gift-code-callout-header {\n            color: #59606D;\n            margin-left: 3px;\n\n            @media screen and (max-width: 735px) {\n                font-size: 16px;\n                line-height: 24px;\n            }\n        }\n    }\n\n    .balance {\n        color: black;\n    }\n\n    .ant-divider {\n        margin: 16px 0;\n        border-top: 1px solid #C9D1DF;\n    }\n\n    .reward-gift-icon {\n        width: 22px;\n        height: 20px;\n    }\n\n    .gift-code-callout {\n        p {\n            margin: 10px 0;\n        }\n\n        &.gift-code-callout-secondary {\n            p {\n                margin-top: 0;\n            }\n        }\n    }\n\n    .gift-code-callout-reward {\n        margin-bottom: 24px;\n\n        .congrats-header {\n            margin: 0;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 24px;\n            color: black;\n        }\n\n        .gift-code-text {\n            margin-bottom: 10px;\n        }\n\n        .anticon {\n            width: 16px;\n            vertical-align: baseline;\n            fill: currentColor;\n        }\n\n        .deck-redeem-btn {\n            float: none;\n            padding: 5px 12px !important;\n            font-size: 12px;\n            line-height: 12px;\n            font-weight: 600;\n            height: 26px;\n            border-color: unset;\n            box-shadow: none;\n            text-shadow: none;\n            display: inline-block;\n\n            &.is-disabled {\n                cursor: not-allowed;\n            }\n\n            .gift-code-redeem-link:hover {\n                color: unset;\n            }\n        }\n\n        .nkl-tag {\n            margin-right: 0;\n        }\n    }\n\n    .gift-code-expiration {\n        margin-right: 10px;\n        margin-left: 10px;\n\n        strong {\n            font-size: 16px;\n        }\n    }\n\n    .nkl-points-display {\n        margin-bottom: 8px;\n        font-weight: 400;\n        font-size: 24px;\n        line-height: 32px;\n        color: #59606D;\n        display: flex;\n        align-items: baseline;\n\n        .points-amount {\n            font-size: 38px;\n            font-weight: 700;\n            margin-right: 6px;\n            line-height: 52px;\n\n            @media screen and (max-width: 735px) {\n                font-size: 30px;\n                line-height: 40px;\n            }\n        }\n\n        .points-label {\n            text-transform: capitalize;\n\n            @media screen and (max-width: 735px) {\n                font-size: 18px;\n                line-height: 28px;\n            }\n        }\n    }\n\n    .nkl-account-display {\n        margin-top: 24px;\n        margin-bottom: 14px;\n\n        p {\n            margin-bottom: 0;\n        }\n\n        &.nkl-account-no-gift-codes {\n            margin-top: 0;\n        }\n    }\n}\n\n.redeem-menu,\n.arcade-menu {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n\n    .redeem-option {\n        flex-basis: auto;\n        padding: 0;\n        width: 100%;\n        text-align: left;\n        display: flex;\n        flex-direction: row;\n        margin-bottom: 8px;\n    }\n\n    .market-link {\n        display: block;\n        cursor: pointer;\n        width: 100%;\n\n        &:hover,\n        &:focus {\n            text-decoration: none;\n\n            .link-label {\n                background-color: #F5F7FA;\n                border-radius: 8px;\n            }\n        }\n\n        &.is-disabled {\n            cursor: not-allowed;\n        }\n    }\n\n    .icon {\n        position: relative;\n        width: 18px;\n        height: 18px;\n        margin: 0 8px 0 4px;\n    }\n\n    svg {\n        position: absolute;\n        top: 0;\n        width: 100%;\n\n        @media screen and (max-width: 735px) {\n            width: auto;\n        }\n    }\n\n    .link-label {\n        display: flex;\n        align-items: center;\n        flex-basis: auto;\n        width: 100%;\n        height: 100%;\n        margin-top: 10px / 2;\n        padding: 14px;\n        color: #000;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 16px;\n        pointer-events: none;\n\n        @media screen and (max-width: 735px) {\n            padding: 0;\n            padding-left: 8px;\n            padding-right: 8px;\n        }\n\n        .rewards-store-description {\n            display: flex;\n            flex-direction: column;\n            align-self: start;\n            max-width: 265px;\n        }\n\n        img {\n            height: 44px;\n            margin-right: 10px;\n            align-self: start;\n        }\n\n        .link-text {\n            font-size: 16px;\n            font-weight: 600;\n            color: black;\n            margin-bottom: 2px;\n            line-height: 24px;\n\n            @media screen and (max-width: 735px) {\n                font-size: 14px;\n                line-height: 20px;\n            }\n        }\n\n        .sub-text {\n            font-size: 14px;\n            font-weight: 400;\n            color: #59606D;\n            line-height: 20px;\n\n            @media screen and (max-width: 735px) {\n                font-size: 12px;\n                line-height: 16px;\n            }\n        }\n    }\n\n    .deck-external-link-icon {\n        position: relative;\n        width: 24px;\n        height: 24px;\n        margin-left: auto;\n        color: #59606D;\n\n        @media screen and (max-width: 735px) {\n            height: 100%;\n            top: 8px;\n        }\n    }\n}\n\n#deck-rewardsPopoverContainer {\n    .ant-popover-inner-content {\n        padding: 0;\n        width: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
